import { codingSchemes } from "../../../../../models/codingSchemes";
import {
    IPublicationDocument,
    coreCountries,
    tableValuesInit,
    IPublicationTimeSerie,
    ITableValues,
} from "../../../../../models/npShifts";

const coreCountriesCodes: string[] = [];
Object.entries(codingSchemes).forEach((e) => {
    const country = e[0].toLowerCase();
    const code = e[1];
    if (coreCountries.includes(country)) coreCountriesCodes.push(code);
});

export const getRefProgs = async (json: IPublicationDocument, timestamp: string): Promise<{ refProgs: ITableValues; hasExchangeData: ITableValues }> => {
    const refProgs = { ...tableValuesInit };
    const hasExchangeData: ITableValues = { ...tableValuesInit };
    Object.entries(codingSchemes).forEach((e) => {
        const country = e[0].toLowerCase();
        const code = e[1];
        if (country in refProgs) {
            let sumIn = 0;
            let sumOut = 0;
            const countryIns = json.publicationTimeSeries.filter(
                (p) => p.inArea.attributes.v === code
            );
            countryIns.forEach((ci) => {
                FixWrongParsedIPublicationTimeSerie(ci);
                sumIn += +ci.period.interval.filter((i) => i.pos.attributes.v === timestamp)[0].qty
                    .attributes.v;
            });
            const countryOuts = json.publicationTimeSeries.filter(
                (p) => p.outArea.attributes.v === code
            );
            countryOuts.forEach((co) => {
                FixWrongParsedIPublicationTimeSerie(co);
                sumOut += +co.period.interval.filter((i) => i.pos.attributes.v === timestamp)[0].qty
                    .attributes.v;
            });
            const hasData = countryIns.length > 0 || countryOuts.length > 0;
            hasExchangeData[country] = hasData ? 1 : 0;
            refProgs[country] = hasData ? Math.round(sumOut - sumIn) : 0;
        }
    });
    return { refProgs, hasExchangeData };
};

export const FixWrongParsedIPublicationTimeSerie = async (iPublicationTimeSerie: IPublicationTimeSerie) => {
    // iPublicationTimeSerie.period.interval should be an array instead an object. Error while parsing LTCC 110 files
    if (iPublicationTimeSerie.period.interval && iPublicationTimeSerie.period.interval.filter == null) {
        let fixedList = [iPublicationTimeSerie.period.interval as any]
        iPublicationTimeSerie.period.interval = fixedList;
    }
    return iPublicationTimeSerie;
};

export const getNpCoresAndNonCores = async (
    json: IPublicationDocument,
    timestamp: string,
    hasExchangeData: ITableValues
): Promise<{ cores: ITableValues; nonCores: ITableValues }> => {
    const npCores = { ...tableValuesInit };
    const npNonCores = { ...tableValuesInit };
    Object.entries(codingSchemes).forEach((cs) => {
        const country = cs[0].toLowerCase();
        const code = cs[1];
        if (country in tableValuesInit) {
            let sumInCore = 0;
            let sumOutCore = 0;
            let sumInNonCore = 0;
            let sumOutNonCore = 0;
            let cores: IPublicationTimeSerie[] = [];
            let nonCores: IPublicationTimeSerie[] = [];
            let coreIns: IPublicationTimeSerie[] = [];
            let coreOuts: IPublicationTimeSerie[] = [];
            if (coreCountries.includes(country)) {
                cores = json.publicationTimeSeries.filter(
                    (c) =>
                        coreCountriesCodes.includes(c.inArea.attributes.v) &&
                        coreCountriesCodes.includes(c.outArea.attributes.v)
                );
                nonCores = json.publicationTimeSeries.filter(
                    (nc) =>
                        (coreCountriesCodes.includes(nc.inArea.attributes.v) &&
                            !coreCountriesCodes.includes(nc.outArea.attributes.v)) ||
                        (!coreCountriesCodes.includes(nc.inArea.attributes.v) &&
                            coreCountriesCodes.includes(nc.outArea.attributes.v))
                );
                coreIns = cores.filter((c) => c.inArea.attributes.v === code);
                coreIns.forEach((ci) => {
                    sumInCore += +ci.period.interval.filter(
                        (i) => i.pos.attributes.v === timestamp
                    )[0].qty.attributes.v;
                });
                coreOuts = cores.filter((c) => c.outArea.attributes.v === code);
                coreOuts.forEach((co) => {
                    sumOutCore += +co.period.interval.filter(
                        (i) => i.pos.attributes.v === timestamp
                    )[0].qty.attributes.v;
                });
            } else {
                // For non-core countries, only calculate nonCores (NP Core is always 0)
                nonCores = json.publicationTimeSeries.filter(
                    (nc) =>
                        !coreCountriesCodes.includes(nc.inArea.attributes.v) &&
                        !coreCountriesCodes.includes(nc.outArea.attributes.v)
                );
            }
            const nonCoreIns = nonCores.filter((nc) => nc.inArea.attributes.v === code);
            nonCoreIns.forEach((nci) => {
                sumInNonCore += +nci.period.interval.filter(
                    (i) => i.pos.attributes.v === timestamp
                )[0].qty.attributes.v;
            });
            const nonCoreOuts = nonCores.filter((nc) => nc.outArea.attributes.v === code);
            nonCoreOuts.forEach((nco) => {
                sumOutNonCore += +nco.period.interval.filter(
                    (i) => i.pos.attributes.v === timestamp
                )[0].qty.attributes.v;
            });
            if (coreCountries.includes(country) && hasExchangeData[country] !== 0) {
                const hasCoreData = coreIns.length > 0 || coreOuts.length > 0;
                npCores[country] = hasCoreData ? Math.round(sumOutCore - sumInCore) : 0;
            } else {
                npCores[country] = 0;
            }
            
            if (hasExchangeData[country] === 0) {
                npNonCores[country] = 0;
            } else {
                const hasNonCoreData = nonCoreIns.length > 0 || nonCoreOuts.length > 0;
                npNonCores[country] = hasNonCoreData ? Math.round(sumOutNonCore - sumInNonCore) : 0;
            }
        }
    });
    return { cores: npCores, nonCores: npNonCores };
};
